<script lang="ts">
	//Stores
	import { user_data } from 'src/stores/account/user';
	//Services
	import { postReq } from '../../../services/http';
	import { handleLogout } from '../../../helpers/account_helpers';
	import { format } from '../../../services/i18n';
	//Helpers
	import { passwordCompare } from '../../../helpers/validators';
	//Types
	import type { ChangeEmailRequest } from '../../../types/requests/settings/user/change_email';
	//Design system components
	import { ButtonV2, InputV2, toast, Text } from '@Shelly/shelly-design-system';
	import { replace } from 'svelte-spa-router';
	import { capFirstChar } from 'src/helpers/utilities';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	let newEmailValue = '',
		repeatEmailValue = '',
		passwordValue = '';

	export let isMobile = false;

	$: mailsError = passwordCompare(newEmailValue, repeatEmailValue)
		? $format('error_emails_match', {
				default: 'The email addresses entered do not match.',
			})
		: undefined;

	$: isFormChanged = newEmailValue !== '' && repeatEmailValue !== '' && passwordValue !== '';
	$: isSaveDisabled = !isFormChanged || passwordCompare(newEmailValue, repeatEmailValue);

	// longer error handle message for non matching e-mails: "'The email addresses entered do not match. Please ensure that both email fields contain the same email address to proceed.'"
	// it might come in handy

	export const handleChangeEmail = async (newMail, oldMail, mailPass, user) => {
		if (newMail !== oldMail) {
			toast.open({
				type: 'info',
				title: $format('error_emails_match', {
					default: 'The email addresses entered do not match.',
				}),
			});
			return;
		} else {
			const res: ChangeEmailRequest = await postReq('/user/change_email', {
				new_email: newMail,
				old_email: $user_data.email,
				password: mailPass,
			});

			if (res.isok) {
				await handleLogout();
				replace('/login');
			} else if (res?.errors) {
				if (res.errors?.wrong_email) {
					return toast.open({
						type: 'danger',
						title: $format('error_email_used', {
							default: 'The new E-mail you provided is already registered to a account.',
						}),
					});
				} else if (res.errors?.wrong_password) {
					return toast.open({
						type: 'danger',
						title: $format('alert_error_wrong_pass', {
							default: 'Wrong password provided.',
						}),
					});
				} else {
					toast.open({ type: 'danger', title: $format('setting_err_toast') });
				}
			}
		}
	};
</script>

<div class="gap-l">
	<!-- First row: New email and Confirm email inputs -->
	<div
		class={classMap({
			'd-flex align-items-center gap-m justify-content-between mb-m': true,
			'flex-direction-column': isMobile,
		})}
	>
		<div class="width-full">
			<Text styleType="body-medium" class="mb-s">
				{capFirstChar($format('placeholder_new_email'))}
			</Text>
			<InputV2
				backgroundColor="color-00"
				icon={null}
				size="l"
				bind:value={newEmailValue}
				type={'text'}
				id="input-wj138ps"
				aria-label={capFirstChar($format('placeholder_new_email'))}
			/>
		</div>
		<div class="width-full">
			<Text styleType="body-medium" class="mb-s">
				{capFirstChar($format('placeholder_repeat_new_email'))}
			</Text>
			<InputV2
				backgroundColor="color-00"
				icon={null}
				size="l"
				error={mailsError}
				bind:value={repeatEmailValue}
				type={'text'}
				id="input-fhg23cb"
				aria-label={capFirstChar($format('placeholder_repeat_new_email'))}
			/>
		</div>
	</div>

	<!-- Second row: Password same width as New email; Save in the right column -->
	<div
		class={classMap({
			'd-flex gap-m justify-content-between': true,
			'align-items-end': !isMobile,
			'flex-direction-column': isMobile,
		})}
	>
		<div class="width-full">
			<Text styleType="body-medium" class="mb-s">
				{capFirstChar($format('placeholder_password'))}
			</Text>
			<InputV2
				backgroundColor="color-00"
				icon={null}
				disableToggleVisibility
				size="l"
				bind:value={passwordValue}
				type={'password'}
				id="input-sfyu0jb"
				aria-label={capFirstChar($format('placeholder_password'))}
			/>
		</div>

		<div
			class={classMap({
				'width-full': true,
				'd-flex justify-content-end': !isMobile,
			})}
		>
			<ButtonV2
				size="m"
				variant="primary"
				class={classMap({
					'width-s': !isMobile,
					'width-full': isMobile,
				})}
				disabled={isSaveDisabled}
				on:click={() =>
					handleChangeEmail(
						newEmailValue,
						repeatEmailValue,
						passwordValue,
						$user_data.email,
					)}
			>
				{$format('button_save')}
			</ButtonV2>
		</div>
	</div>
</div>

